import SFetch from '@app/utils/sfetch'

export function getBudgetSetImport(
  budgetSetId: number,
  budgetSetImportId: number
): Promise<void | null | {
  id: number
  validationStatus: Record<string, string>
}> {
  const path = window.Silverfin.Routes.budget_set_budget_set_import_path({
    firm_id: window.Silverfin.currentFirmId,
    company_id: window.Silverfin.currentCompanyId,
    budget_set_id: budgetSetId,
    id: budgetSetImportId,
    _options: true,
  })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return SFetch.jsonWithAlert<{
    id: number
    validationStatus: Record<string, string>
  }>(path)
}

export function createBudgetSetImport(
  budgetSetId: number,
  params: Record<string, Record<string, string>>
): Promise<void | null | { id: number; messageBusLastId: number }> {
  const path = window.Silverfin.Routes.budget_set_budget_set_imports_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    budgetSetId
  )

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return SFetch.jsonWithAlert<{ id: number; messageBusLastId: number }>(path, {
    method: 'POST',
    body: params,
  })
}

export function updateBudgetSetImport(
  budgetSetId: number,
  budgetSetImportId: number
): Promise<void | null | { id: number; messageBusLastId: number }> {
  const path = window.Silverfin.Routes.budget_set_budget_set_import_path({
    firm_id: window.Silverfin.currentFirmId,
    company_id: window.Silverfin.currentCompanyId,
    budget_set_id: budgetSetId,
    id: budgetSetImportId,
    _options: true,
  })

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return SFetch.jsonWithAlert<{ id: number; messageBusLastId: number }>(path, {
    method: 'PUT',
  })
}
